import Vue from "vue";
import Router from "vue-router";
import Frontpage from "./components/Frontpage.vue";
import Home from "./components/Home.vue";
import UserRegister from "./components/UserRegister.vue";
import UserLogin from "./components/UserLogin.vue";
import UserForgotPassword from "./components/UserForgotPassword.vue";
import { i18nConfig } from "./main.js";
import { Auth } from "aws-amplify";

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:lang",
      name: "lang",
      component: Frontpage,
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "de"].includes(lang)) return next("de");
        if (i18nConfig.locale !== lang) {
          i18nConfig.locale = lang;
        }
        return next();
      },
      children: [
        {
          path: "home",
          name: "home",
          component: Home,
          // see https://router.vuejs.org/guide/advanced/meta.html
          meta: { requiresAuth: true }
        },
        {
          path: "user/register",
          name: "register",
          component: UserRegister
        },
        {
          path: "user/login",
          name: "login",
          component: UserLogin
        },
        {
          path: "user/forgot-password",
          name: "forgot-password",
          component: UserForgotPassword
        }
        // },
        // {
        //   path: "about",
        //   name: "about",
        //   // route level code-splitting
        //   // this generates a separate chunk (about.[hash].js) for this route
        //   // which is lazy-loaded when the route is visited.
        //   component: () =>
        //     import(/* webpackChunkName: "about" */ "./views/About.vue")
        // }
      ]
    },
    {
      path: "*",
      redirect: "/de"
    }
  ]
});
// see https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    Auth.currentAuthenticatedUser({
      bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    })
      .then(user => {
        console.log("router requiresAuth call:", user);
        console.log(to);
        let lang = to.params.lang;
        if (!["en", "de"].includes(lang)) {
          lang = "de";
        }
        if (i18nConfig.locale !== lang) {
          i18nConfig.locale = lang;
        }
        next();
      })
      .catch(err => {
        // Not logged in.
        console.log("currentAuthenticatedUser:", err);
        console.log("to:", to);
        let lang = to.params.lang;
        if (!["en", "de"].includes(lang)) {
          lang = "de";
        }
        if (i18nConfig.locale !== lang) {
          i18nConfig.locale = lang;
        }
        next({
          name: "login",
          params: {
            lang: lang
          }
        });
      });
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
